import React from 'react';

interface IProps {
  icon: any;
  title: string;
  count?: number | string;
  isBlackText?: boolean;
}

const ProfileList: React.FC<IProps> = ({ icon, title, count, isBlackText }) => {
  return (
    <div className="flex items-center justify-between my-3">
      <div className="flex items-center space-x-4">
        {icon}
        <p
          className={`${
            isBlackText ? 'text-text-black' : 'text-light-grey'
          }  text-base`}
        >
          {title}
        </p>
      </div>
      {count && (
        <p className="text-text-black font-semibold text-sm"> {count} </p>
      )}
    </div>
  );
};

export default React.memo(ProfileList);
